import '../../assets/css/case-property.css';
// @ts-ignore
import { useProperty, useContentToken, EditableToken, useOfficeHours } from '@vibesites/runtime/react';
// @ts-ignore
import type { ComponentContentSchema } from '@vibesites/runtime';
import { formatTime24to12, formatHoursRange, sortOfficeHours } from './propertyUtils';

interface OfficeHourEntry {
  day?: string;
  open?: string;
  close?: string;
  label?: string;
  hours?: string;
}

export function OfficeHours() {
  useProperty();
  const officeHours = useOfficeHours() as OfficeHourEntry[];
  const heading = useContentToken('officehours.heading');

  if (officeHours.length === 0) return null;

  return (
    <section className="prop-hours-section">
      <div className="prop-container">
        <EditableToken path="officehours.heading" type="text" label="Heading" defaultValue={contentSchema.tokens['officehours.heading'].defaultValue} as="h2" className="prop-hours-heading">
          {heading}
        </EditableToken>
        <table className="prop-hours-table">
          <tbody>
            {sortOfficeHours(officeHours).map((entry, i) => {
              const label = entry.label || entry.day || '';
              const hours = entry.label && entry.hours
                ? formatHoursRange(entry.hours)
                : entry.open && entry.close
                  ? `${formatTime24to12(entry.open)} - ${formatTime24to12(entry.close)}`
                  : 'Closed';
              return (
                <tr key={i}>
                  <td className="prop-hours-day">{label}</td>
                  <td className="prop-hours-time">{hours}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'OfficeHours',
  displayName: 'Office Hours',
  tokens: {
    'officehours.heading': {
      label: 'Heading',
      type: 'text',
      defaultValue: 'Office Hours',
    },
  },
};

(OfficeHours as unknown as { contentSchema: ComponentContentSchema }).contentSchema = contentSchema;

export default OfficeHours;
